import React from "react";
import { NavLink } from 'react-router-dom';
import "./RoutesMenu.sass";

export const RoutesMenu = () => {
  return (
    <div className="RoutesMenu row">
      <nav>
        <ul>
          <li>
            <NavLink to="/rutas-y-reglamentacion/resumen">Resumen</NavLink>
          </li>
          <li>
            <NavLink to="/rutas-y-reglamentacion/prologo">Prólogo</NavLink>
          </li>
          <li>
            <NavLink to="/rutas-y-reglamentacion/etapa-1">Etapa 1</NavLink>
          </li>
          <li>
            <NavLink to="/rutas-y-reglamentacion/etapa-2">Etapa 2</NavLink>
          </li>
          <li>
            <NavLink to="/rutas-y-reglamentacion/etapa-3">Etapa 3</NavLink>
          </li>
          <li>
            <NavLink to="/rutas-y-reglamentacion/etapa-4">Etapa 4</NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};
